import { format } from "date-fns";
import { type GetListParams } from "react-admin";

import { createApiClient } from "@/api";
import { DEFAULT_DATE_FORMAT } from "@/constants/date";
import { getLocalFilteredSortedList } from "@/utils/listParams";

import { type StatisticsFilter, type StatisticsHydraMember } from "./types";

const apiClientLd = createApiClient("jsonld");
const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/common_statistics";

export const fetchStatisticsListData = async ({ filter }: GetListParams) => {
  const typedFilter = (filter as StatisticsFilter | undefined) ?? {};
  const {
    date_start: dateStart,
    date_end: dateEnd,
    our_traffic_source: ourTrafficSource,
    country,
    clientApp,
  } = typedFilter;
  const { data } = await apiClientLd.GET(BASE_URL, {
    params: {
      query: {
        group: typeof typedFilter.group === "string" ? typedFilter.group : "",
        tracker:
          typeof typedFilter.tracker === "string" ? typedFilter.tracker : "",
        ...typedFilter,
        our_traffic_source: ourTrafficSource?.join(","),
        country: country?.join(","),
        date_start: dateStart
          ? format(new Date(dateStart), DEFAULT_DATE_FORMAT)
          : "",
        date_end: dateEnd ? format(new Date(dateEnd), DEFAULT_DATE_FORMAT) : "",
        client_app_id: clientApp?.split("/").pop(),
        order_name: "group",
        order_type: "desc",
      },
    },
  });

  const hydraMember = (data?.["hydra:member"] ?? {}) as StatisticsHydraMember;

  return {
    data: Object.entries(hydraMember).map(([key, value]) => ({
      ...value,
      id: key,
    })),
    total: data?.["hydra:totalItems"] ?? 0,
  };
};

export const fetchStatisticsGroups = async () => {
  const { data = [] } = await apiClient.GET(`${BASE_URL}/groups`, {
    params: {
      // @ts-expect-error надо поинвестигейтить что именно тут не так
      query: {
        pagination: false,
      },
    },
  });
  return {
    data,
    total: data.length,
  };
};

export const statisticsSchema = {
  list: getLocalFilteredSortedList(fetchStatisticsListData),
};
